module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<a\n	class="img_holder custom_call_to_action_anchor" \n	role="' +
((__t = ( photoItemRole() )) == null ? '' : __t) +
'" \n	href="' +
((__t = ( getCustomCallToActionLink() )) == null ? '' : __t) +
'"\n	target="' +
((__t = ( ctaTarget() )) == null ? '' : __t) +
'"\n	' +
((__t = ( backgroundImage(thumbnail(tap2shop_thumbnail_size)) )) == null ? '' : __t) +
'\n	aria-label="' +
((__t = ( I18n.t(contentType(), { altText: decodeUtf8(altText()) }) )) == null ? '' : __t) +
'"\n>\n<img src="';
 thumbnail(tap2shop_thumbnail_size) ;
__p += '" alt="' +
((__t = ( decodeUtf8(altText()) )) == null ? '' : __t) +
'" style="position: fixed; left: -100000px;" data-prod-image="' +
((__t = (getReview().productImage)) == null ? '' : __t) +
'"/>\n\n	';
 if (isStory()) { ;
__p += '\n		<div class="story" aria-hidden="true"></div>\n	';
 } ;
__p += '\n\n	';
 if (isVideo()) { ;
__p += '\n		<div class="layer_video lightboxed" id="' +
((__t = ( album_photo_id )) == null ? '' : __t) +
'" rel=\'album\' aria-hidden="true">\n			<div class="play_button" aria-hidden="true"></div>\n		</div>\n	';
 } ;
__p += '\n\n	';
 if (hasReview()) { ;
__p += '\n		<div class="text_review_holder" data-review-id="' +
((__t = ( getReview().id )) == null ? '' : __t) +
'">\n			<div class="text_review_content">\n				<p class="star_holder star_' +
((__t = ( getReview().score )) == null ? '' : __t) +
'">' +
((__t = ( I18n.t('photo_item.review.star_rating', { reviewScore: getReview().score }) )) == null ? '' : __t) +
'</p>\n				<p class="text_review">' +
((__t = ( getReview().content )) == null ? '' : __t) +
'</p>\n			</div>\n			<p class="reviewer_name">' +
((__t = ( getReview().user_name )) == null ? '' : __t) +
'</p>\n		</div>\n	';
 } ;
__p += '\n</a>';

}
return __p
}